import React from 'react';

function SendMifs() {
  return <div>SendMifs</div>;
}

export default SendMifs;
